import "../../../css/OnRoad.css";

export default function OnRoadHeader({ nombreEmpresa, manifiesto, conductor }) {
    return (
        <div className="onroad-header">
            <div className="onroad-header-content">
                <div className="header-info">
                    <h1 className="company-name">{nombreEmpresa}</h1>
                    <div className="manifest-info">
                        <span className="conductor-name">{conductor}</span>
                        <span className="manifest-separator">•</span>
                        <span className="manifest-number">{manifiesto}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}